import type { BrandIconGlyph } from "@gusarov-studio/rubik-ui";

const providerKeys = {
  OPENAI: "openai",
  ANTHROPIC: "anthropic",
  GEMINI: "gemini",
  MISTRAL: "mistral",
  XAI: "xai",
} as const;

type ProviderKeySlug = (typeof providerKeys)[keyof typeof providerKeys];

interface ProviderMeta {
  slug: ProviderKeySlug;
  name: string;
  displayIcon: BrandIconGlyph;
  apiKey: {
    providerUrl: string;
    placeholder: string;
    pattern: RegExp;
  };
}

const providerMeta: Record<ProviderKeySlug, ProviderMeta> = {
  [providerKeys.OPENAI]: {
    slug: providerKeys.OPENAI,
    name: "OpenAI",
    displayIcon: "chat-gpt-4",
    apiKey: {
      providerUrl: "https://platform.openai.com/api-keys",
      placeholder: "sk-proj-••••••••••••••••••••••••••••••••••••••",
      // Modern OpenAI keys use sk-proj-* and legacy format may still exist for some users.
      pattern: /^sk-(proj-)?[A-Za-z0-9_-]{20,}$/,
    },
  },
  [providerKeys.ANTHROPIC]: {
    slug: providerKeys.ANTHROPIC,
    name: "Anthropic",
    displayIcon: "claude",
    apiKey: {
      providerUrl: "https://console.anthropic.com/settings/keys",
      placeholder: "sk-ant-••••••••••••••••••••••••••••••••••••••",
      pattern: /^sk-ant-[A-Za-z0-9_-]{16,}$/,
    },
  },
  [providerKeys.GEMINI]: {
    slug: providerKeys.GEMINI,
    name: "Google AI",
    displayIcon: "gemini",
    apiKey: {
      providerUrl: "https://aistudio.google.com/app/apikey",
      placeholder: "AIzaSy••••••••••••••••••••••••••••••••••",
      pattern: /^[\.A-Za-z0-9_-]{16,}$/,
    },
  },
  [providerKeys.MISTRAL]: {
    slug: providerKeys.MISTRAL,
    name: "Mistral",
    displayIcon: "mistral",
    apiKey: {
      providerUrl: "https://console.mistral.ai/api-keys/",
      placeholder: "••••••••••••••••••••••••••••••••",
      pattern: /[A-Za-z0-9_-]{32,}$/,
    },
  },
  [providerKeys.XAI]: {
    slug: providerKeys.XAI,
    name: "xAI",
    displayIcon: "xai",
    apiKey: {
      providerUrl: "https://console.x.ai/",
      placeholder: "xai-••••••••••••••••••••••••••••••••••••••",
      pattern: /^xai-[A-Za-z0-9_-]{20,}$/,
    },
  },
};

const providerKeySlugs = Object.values(providerKeys) as ProviderKeySlug[];

export { providerKeys, providerKeySlugs, providerMeta, type ProviderMeta, type ProviderKeySlug };
